import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { languages } from 'app/utils/supportedLanguages';
import { CustomizationPage } from './CustomizationPage';
export function CustomizationPageRoute({ loadDixaMessengerSettingsAllLevels, mode, onSubmit, params, }) {
    const { language: languageCode, settingsId } = params;
    useEffect(loadDixaMessengerSettingsAllLevels, [
        loadDixaMessengerSettingsAllLevels,
    ]);
    if (!languageCode || !mode) {
        throw new Error(`${CustomizationPageRoute.name} expects to have router params to have the "languageCode" field.`);
    }
    const language = languages.find(({ code }) => code === (languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLocaleLowerCase()));
    if (!language) {
        return _jsx(Navigate, { to: "/settings/satisfaction/email" });
    }
    return (_jsx(CustomizationPage, { languageName: language.label || '', settingsId: settingsId, mode: mode, onSubmit: onSubmit }));
}
